// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#eead06","footer__footer":"styles_footer__footer__F0Vek"};